module.exports = __webpack_public_path__ + "img/icon_hot2.dc0de067.png";